export const REGEX_PATTERNS = {
  NUMBER_WITH_COMMAS: {
    FIRST_HALF: /(\d)(?=(\d{3})+(?!\d))/g,
    SECOND_HALF: "$1,",
  },
};
